import actions from './moduleDashboardActions';
import mutations from './moduleDashboardMutations';
import getters from './moduleDashboardGetters';
import state from './moduleDashboardState';

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};
